import { Injectable } from "@angular/core";
import { App } from "@capacitor/app";
import { PluginListenerHandle } from "@capacitor/core";
import { BehaviorSubject } from "rxjs";
import { IUserLoginService } from "../interfaces/IUserLoginService";
import { LoggerService } from "./logs/logger.service";

@Injectable({
    providedIn: "root",
})
export class AppStateManagementService {
    private appStateListener: PluginListenerHandle | undefined;
    private isAppActive = new BehaviorSubject<boolean>(true);

    public isAppActive$ = this.isAppActive.asObservable();

    constructor(private loggerService: LoggerService,
                private userService: IUserLoginService) {
    }

    public async initialize() {
        this.appStateListener = await App.addListener("appStateChange", async (state) => {
            this.isAppActive.next(state.isActive);

            if (state.isActive) {
                await this.handleAppResume();
            } else {
                await this.handleAppPause();
            }
        });
    }

    public async destroy() {
        if (this.appStateListener) {
            await this.appStateListener.remove();
        }
    }

    private handleAppPause() {
        this.loggerService.info(this.constructor.name, "App paused - Global handler");
        // Logique globale à exécuter à la pause

        return Promise.resolve();
    }

    private async handleAppResume() {
        this.loggerService.info(this.constructor.name, "App resumed - Global handler");

        if (await this.userService.isConnected()) {
            await this.userService.checkToken();
        }
    }
}